const FileWord = ({ size }: { size: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M4.75 14.5H14.25C14.3875 14.5 14.5 14.3875 14.5 14.25V4.5H12.25C11.8365 4.5 11.5 4.1635 11.5 3.75V1.5H4.75C4.6125 1.5 4.5 1.6125 4.5 1.75V14.25C4.5 14.3875 4.6125 14.5 4.75 14.5Z"
      fill="#FFFFFF"
    />
    <path
      d="M14.1465 4.00002L12 1.85352V3.75002C12 3.88752 12.1125 4.00002 12.25 4.00002H14.1465Z"
      fill="#FFFFFF"
    />
    <path
      opacity="0.64"
      d="M14.78 3.927L12.073 1.2195C11.9321 1.07945 11.7417 1.00058 11.543 1H4.75C4.3365 1 4 1.3365 4 1.75V14.25C4 14.6635 4.3365 15 4.75 15H14.25C14.6635 15 15 14.6635 15 14.25V4.457C15 4.257 14.922 4.0685 14.78 3.927ZM12 1.8535L14.1465 4H12.25C12.1838 3.99987 12.1202 3.97349 12.0733 3.92663C12.0265 3.87978 12.0002 3.81627 12 3.75V1.8535ZM14.25 14.5H4.75C4.68373 14.4998 4.62022 14.4735 4.57337 14.4267C4.52651 14.3798 4.50013 14.3162 4.5 14.25V1.75C4.5 1.6125 4.6125 1.5 4.75 1.5H11.5V3.75C11.5 4.1635 11.8365 4.5 12.25 4.5H14.5V14.25C14.5 14.3875 14.3875 14.5 14.25 14.5Z"
      fill="#605E5C"
    />
    <path
      d="M12.75 11H8.5V11.5H12.75C12.8163 11.5 12.8799 11.4736 12.9268 11.4268C12.9736 11.3799 13 11.3163 13 11.25C13 11.1837 12.9736 11.1201 12.9268 11.0732C12.8799 11.0264 12.8163 11 12.75 11Z"
      fill="#103F91"
    />
    <path
      d="M12.75 9.5H8.5V10H12.75C12.8163 10 12.8799 9.97365 12.9268 9.9268C12.9736 9.8799 13 9.8163 13 9.75C13 9.6837 12.9736 9.6201 12.9268 9.5732C12.8799 9.52635 12.8163 9.5 12.75 9.5Z"
      fill="#185ABD"
    />
    <path
      d="M12.75 8H8.5V8.5H12.75C12.8163 8.5 12.8799 8.47365 12.9268 8.4268C12.9736 8.3799 13 8.3163 13 8.25C13 8.1837 12.9736 8.1201 12.9268 8.0732C12.8799 8.02635 12.8163 8 12.75 8Z"
      fill="#2B7CD3"
    />
    <path
      d="M12.75 6.5H8.5V7H12.75C12.8163 7 12.8799 6.97365 12.9268 6.9268C12.9736 6.8799 13 6.8163 13 6.75C13 6.6837 12.9736 6.6201 12.9268 6.5732C12.8799 6.52635 12.8163 6.5 12.75 6.5Z"
      fill="#41A5EE"
    />
    <path
      d="M1.75 12.5H7.25C7.4489 12.5 7.6397 12.421 7.78035 12.2803C7.921 12.1397 8 11.9489 8 11.75V6.25C8 6.0511 7.921 5.8603 7.78035 5.71965C7.6397 5.579 7.4489 5.5 7.25 5.5H1.75C1.55109 5.5 1.36032 5.579 1.21967 5.71965C1.07902 5.8603 1 6.0511 1 6.25V11.75C1 11.9489 1.07902 12.1397 1.21967 12.2803C1.36032 12.421 1.55109 12.5 1.75 12.5Z"
      fill="#185ABD"
    />
    <path
      d="M3.6075 10.365H3.6185C3.623 10.3075 4.185 7.5 4.185 7.5H4.838C4.838 7.5 5.408 10.1765 5.4255 10.36H5.434C5.4415 10.234 5.906 7.5 5.906 7.5H6.5L5.769 11H5.0745C5.0745 11 4.498 8.235 4.4935 8.186H4.4845C4.4795 8.2425 3.943 11 3.943 11H3.238L2.5 7.5H3.105C3.105 7.5 3.605 10.3035 3.6075 10.365Z"
      fill="#F9F7F7"
    />
  </svg>
);

export default FileWord;
